import { defineStore } from 'pinia'
import api from '@/api'

export interface Country {
  id: number
  slug: string
  name: string
}

export interface Currency {
  id: number
  name: string
  symbol: string
  code: string
  active: boolean
}

export const useUtilitiesStore = defineStore('utilities', {
  state: () => ({
    countries: [] as Country[],
    currencies: [] as Currency[],
    loading: false,
    error: null as string | null,
    countriesLoaded: false,
    countriesLoading: false,
  }),
  actions: {
    async fetchCountries(force = false) {
      // Return early if already loaded (countries don't change)
      if (this.countriesLoaded && this.countries.length > 0 && !force) {
        return
      }
      
      // If already loading, wait for existing request
      if (this.countriesLoading) {
        while (this.countriesLoading) {
          await new Promise(resolve => setTimeout(resolve, 50))
        }
        // Check again after waiting
        if (this.countriesLoaded && this.countries.length > 0) {
          return
        }
      }
      
      this.countriesLoading = true
      this.loading = true
      this.error = null
      try {
        const { data } = await api.get('/countries')
        if (data && data.result) {
          this.countries = data.result
          this.countriesLoaded = true
        }
      } catch (e: any) {
        this.error = e?.userMessage || e?.message || 'Failed to fetch countries'
      } finally {
        this.loading = false
        this.countriesLoading = false
      }
    },
    async fetchCurrencies(force = false) {
      // Return early if already loaded (currencies don't change often)
      if (this.currencies.length > 0 && !force) {
        return
      }
      
      this.loading = true
      this.error = null
      try {
        const { data } = await api.get('/currencies')
        if (data && data.result) {
          this.currencies = data.result
        }
      } catch (e: any) {
        this.error = e?.userMessage || e?.message || 'Failed to fetch currencies'
      } finally {
        this.loading = false
      }
    }
  }
}) 